export default __webpack_public_path__ + "static/media/f4.edcb7034.jpg";